import * as React from 'react';
import Box from '../../../parts/Box';
import {IInputSequenceComponentPropsData, IInputSequenceComponentPropsFunctions} from '../props/IInputSequenceComponentProps';
import {ll_url} from '../../../tools';
import {toolName, exampleSeq} from "../../../settings";


import { Container, Col, Button, Row,  Form, FormGroup,FormText, Label, Input, Table,  } from 'reactstrap';
import HelpTooltip from '../../../commons/HelpTooltip';

type IProps = IInputSequenceComponentPropsData & IInputSequenceComponentPropsFunctions & { history: any };
class InputSequenceComponent extends React.Component<IProps> {

    infoRef = React.createRef<HTMLFormElement>();
         
    
    state = {
        aboutBoxHidden: false,
        IFboxHidden : false,  // input format selection
        StructureboxHidden : true,
        SequenceboxHidden : true,
        activeItem: "1", 
        button:true,
        grid_box_clicked: false,
        enterPdbHidden: false,
        uploadPdbHidden: true,
        sequence: true,
        uniprotId: false,
        sequenceFileHidden: true,
        ownTemplate : false,
        ownAlignment: true,
        enterPdbCode: true,
        uploadPdbFile: false,
        alignmentFile: false,
        newModelBox: false,
        existingModelBox: true,
    }

    handleSubmit = () => {        
        let valid = this.infoRef.current.reportValidity();
        if (valid) {
            this.props.submitInput();
        }
    }

    handleHideAbout = () => {
        localStorage.aboutBoxHidden = JSON.stringify(true);
        this.setState({
            aboutBoxHidden: true
        });
        
    }

    handleShowSequenceInputBox = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            StructureboxHidden : true,  
            SequenceboxHidden : false 
        });
    }

    handleShowStructureInputBox = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            StructureboxHidden : false,  
            SequenceboxHidden : true 
        });       
    }

    handldeShowSequenceInputBox = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            sequence: true,
            uniprotId: false,
            sequenceFileHidden: true,
        })

    }
    handldeShowUniprotIdInputBox = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            sequence: false,
            uniprotId: true,
            sequenceFileHidden: true,
        })

    }
    handldeShowSequenceFileInputBox = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            sequence: false,
            uniprotId: false,
            sequenceFileHidden: false,
        })

    }
    handleOwnTemplate = () => {
        this.setState({
            ownTemplate: true,
        })

    }
    handleNewModelBox = () => {
        this.setState({
            newModelBox: true,
            existingModelBox: false,
        })
    }
    handleExistingModel = () =>{
        this.setState({
            existingModelBox: true,
            newModelBox: false,
        })
    }

    useSelectedTool = () => {
        this.setState({
            ownTemplate: false,           
        })
    }
    handleOwnAlignment = () => {
        this.setState({
            ownAlignment: !this.state.ownAlignment,
            alignmentFile: !this.state.alignmentFile,
        })

    }
    handleEnterPdbCode = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            enterPdbCode: true,
            uploadPdbFile: false,   
        })
    }
    handleUploadPdbFile = () => {
        localStorage.MPboxHidden = JSON.stringify(true);
        this.setState({
            enterPdbCode: false,
            uploadPdbFile: true,      
        })
    }
    
    handleSequenceFromID = () => {
       const result = this.props.sequenceFromID(this.props.uniprotIdField);
       //this.props.checkSequence(this.props.sequence);
    } 

    checkSequence = () => {
        this.props.checkSequence(this.props.sequence);
    }

    handleLoadExample = () => {
        this.props.changesequence(exampleSeq);
        this.props.checkSequence(this.props.sequence);
    }

    handleUploadSequenceFile = e => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = () => {
            var seq = '' + reader.result;
            seq = seq.replace(/\s+/g, '');
            this.props.changesequence(seq);
        }
    }

/* ----------------------------------------------------------------------------------------------------------------------------- */
    render() {
        return <div>
              <Box title = "INPUT SEQUENCE" button={
                <Button className = "ll-example-button" onClick={this.handleLoadExample}>Load example</Button>
              }>
                <div>                   
                 <Form>

                 <FormGroup tag="fieldset" row>
                    <Label for="source_radio" style = {{color: "#09A0A8",fontWeight: "bold"}} sm={2}>Source:</Label>
                    <Col sm={10}>
                        <FormGroup check>
                            <Label check >
                            <Input type="radio" name="op1" value = "1" defaultChecked onClick = {this.handldeShowSequenceInputBox} />{' '}
                            Enter own sequence
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                            <Input type="radio" name="op1" value = "2" onClick = {this.handldeShowUniprotIdInputBox} />{' '}
                            Enter Uniprot ID
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                            <Input type="radio" name="op1" value = "3" onClick = {this.handldeShowSequenceFileInputBox} />{' '}
                            Upload sequence file
                            </Label>
                        </FormGroup>
                        </Col>
                    </FormGroup>


                    {!this.state.sequence? null:
                    <FormGroup tag="fieldset" row>
                    <Label htmlFor="sequence" style = {{color: "#09A0A8", fontWeight: "bold"}}sm = {2}>Sequence:
                        <HelpTooltip>
                            Please enter raw sequence.
                        </HelpTooltip> 
                    </Label>                   
                        <Col sm={10}>
                                        <div className = "form-group">
                                            <Input type="textarea" className="form-control" id="sequence_text" 
                                                style = {{width: "300px" , height: "100px"}} 
                                                value={this.props.sequence}
                                                
                                                onChange={evt => this.props.changesequence(evt.target.value)}
                                            />
                                        </div>  
                        <Button onClick={this.checkSequence}>
                            Process Sequence
                        </Button> 
                        {!this.props.sequenceChecked ? null :
                            <img src={ll_url("/images/tick.png")} />
                        }                    
                        </Col>
                    </FormGroup>
                    }

                    {!this.state.uniprotId? null:
                    <FormGroup tag="fieldset" row>
                    <Label htmlFor="uniprotIdField" style = {{color: "#09A0A8", fontWeight: "bold"}}sm = {2}>Uniprot ID:
                        <HelpTooltip>
                            Please enter Uniprot ID.
                        </HelpTooltip> 
                    </Label>                  
                        <Col sm={10}>
                            <div className = "form-group">
                                <Input type="text" className="form-control" id="uniprot_id" 
                                    style = {{width: "150px" , height: "30px"}} 
                                    value={this.props.uniprotIdField}
                                    onChange={evt => this.props.changeUniprotIdField(evt.target.value)}
                                />
                            </div>                           
                        <Button onClick={this.handleSequenceFromID}>
                        Process ID                        
                        </Button>
                        {!this.props.sequenceChecked ? null :
                            <img src={ll_url("/images/tick.png")} />
                        }  
                        </Col>
                    </FormGroup>
                    }

                    {this.state.sequenceFileHidden? null:
                     <FormGroup tag="fieldset" row>
                     <Label htmlFor="sequenceFileField" style = {{color: "#09A0A8", fontWeight: "bold"}}sm = {2}>
                         Sequence file:
                        <HelpTooltip>
                             Please upload your file.
                        </HelpTooltip>
                     </Label>
                         <Col sm={10}>
                                 <FormGroup>
                                    <Input
                                    id="sequence_file"
                                    name="file"
                                    type="file"
                                    onChange={this.handleUploadSequenceFile}
                                    />
                                    <FormText>
                                    Choose raw sequence file.
                                    </FormText>
                                </FormGroup>
                         <Button onClick={this.checkSequence}>
                            Process Sequence
                         </Button>
                         {!this.props.sequenceChecked ? null :
                            <img src={ll_url("/images/tick.png")} />
                        }  
                         </Col>
                     </FormGroup>
                    }

                    { /*
                    <FormGroup tag="fieldset" row>
                    <Label style = {{color: "#09A0A8",fontWeight: "bold"}} sm={2}>PDB ID:</Label>
                    <form id = "ll-input-info" ref={this.infoRef}>
                    <div className = "form-group">
                        <Input type="text" className = 'form-control' id="pdb_id_input"
                            style = {{width: "150px" , height: "30px"}}
                            value={""}
                            onClick={evt => this.props.changePdbIdField((evt.target as HTMLInputElement).value)}
                        />
                        </div>
                        </form>
                        <Label style = {{color: "#09A0A8",fontWeight: "bold"}} sm={2}>Chain:</Label>
                        <form id = "ll-input-info" ref={this.infoRef}>
                        <div className = "form-group">
                         <Input type="text" className = 'form-control' id="chain_input"
                              style = {{width: "150px" , height: "30px"}}
                              value={""}
                              onClick={evt => this.props.changePdbIdField((evt.target as HTMLInputElement).value)}
                         />
                         </div>
                         </form>
                          <Button>
                              Download template
                          </Button>
                    </FormGroup>
                */}
                    {/*
                    <FormGroup tag="fieldset" row>
                        <Label for="modelling" style = {{color: "#09A0A8",fontWeight: "bold"}} sm={2}>Modelling:</Label>
                        <Col sm={10}>
                        <FormGroup check >
                            <Label check
                                onChange={() => this.props.toggleModelling()}
                                >
                                <Input checked={!this.props.modelling} type ="radio" name="op2" defaultChecked onClick = {this.handleExistingModel} />{' '}
                                Download existing model
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check
                                onChange={() => this.props.toggleModelling()}
                                >
                                <Input checked={this.props.modelling}  type ="radio" name="op2" onClick = {this.handleNewModelBox} />{' '}
                                Create new model
                            </Label>
                        </FormGroup>
                    </Col>                      
                    </FormGroup>
                   */}

                   {!this.state.newModelBox? null:
                    <Form>         

                    <FormGroup tag="fieldset" row>
                        <Label for="input" style = {{color: "#09A0A8",fontWeight: "bold"}} sm={2}>Input:</Label>
                        <Col sm={10}>
                            <FormGroup check>
                                <Label check>
                                    <Input type ="radio" name="op4" defaultChecked onClick = {this.useSelectedTool}/>{' '}
                                    Use selected tool for template search and alignment
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type ="radio" name="op4" onClick = {this.handleOwnTemplate} />{' '}
                                    Enter own template
                                </Label>
                            </FormGroup>
                            
                        </Col>  
                    </FormGroup>


                    {!this.state.ownTemplate? null:
                    <FormGroup tag="fieldset" row>            
                    <Label for="own_template" style = {{color: "#09A0A8",fontWeight: "bold"}} sm={2}>Template source:</Label>
                    <Col sm={10}>
                        <FormGroup check>
                            <Label check>
                                <Input type ="radio" name="op5" defaultChecked onClick = {this.handleEnterPdbCode} />{' '}
                                Enter PDB code
                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <Input type ="radio" name="op5" onClick = {this.handleUploadPdbFile} />{' '}
                                Upload PDB file
                            </Label>
                        </FormGroup>                 
                    </Col> </FormGroup>
                    }

                    {!this.state.ownTemplate? null:              
                
                    <FormGroup tag="fieldset" row>            
                    <Label for="own_alignment" style = {{color: "#09A0A8",fontWeight: "bold"}} sm={2}>
                        Own alignment:</Label>
                    <Col sm={10}>
                        <FormGroup check>
                            <Label check>
                                <Input type ="checkbox"  onClick = {this.handleOwnAlignment} />{' '}
                                Enter own alignment
                            </Label>
                                    <Input
                                    id="pdb"
                                    name="file"
                                    type="file"
                                    disabled={!this.state.alignmentFile}
                                    />
                                    <FormText>
                                    Choose pdb file.
                                    </FormText>
                                </FormGroup>
                    </Col>
                    </FormGroup>
                
                    }   

                   
                {!this.state.enterPdbCode? null:
                <FormGroup tag="fieldset" row> 
                        <Label style = {{color: "#09A0A8",fontWeight: "bold"}} sm={2}>PDB ID:
                            <HelpTooltip>
                                Insert the PDB ID of the template.
                            </HelpTooltip> 
                        </Label>
                    </FormGroup>                             
                }
                {!this.state.uploadPdbFile? null:
                <Row>                  
                <Label htmlFor="pbdIdFieldTemplate" style = {{color: "#09A0A8", fontWeight: "bold", boxSizing: "unset"}}sm = {2}>
                    PDB FILE:
                    <HelpTooltip>
                        Choose your file.
                    </HelpTooltip>
                </Label>
                
                <form id = "ll-input-info" ref={this.infoRef}>
                <FormGroup>
                                    <Input
                                    id="pdb_file"
                                    name="file"
                                    type="file"
                                    />
                                    <FormText>
                                    Choose pdb file.
                                    </FormText>
                                </FormGroup>
                            </form>         
                 </Row>

                }

                </Form>
                } 
                </Form>
                </div>                
              </Box>

        </div>
    }
}

export default InputSequenceComponent;
